<template>
  <div class="x_panel">
    <div class="x_title">
      <slot name="title"></slot>
      <div class="col-md-10">
      <form class="form-horizontal" style="display: inline">
        <div
          v-if="filter && showPanel"
          :class="[
            'col-md-4 input-group',
            filterText !== '' ? 'borderfix' : ''
          ]"
        >
          <input
            v-model="filterText"
            type="text"
            class="form-control"
            placeholder="Filter"
          />
          <span 
            v-if="filterText !== ''"
            :class="[
              'input-group-btn'
            ]"
          >
            <button 
              v-on:click="clearSearch()" 
              type="button" 
              class="btn btn-link btn-danger"
            >
              <i class="fa fa-times"></i> 
            </button>
          </span>
        </div>
      </form>
      </div>

      <ul class="nav navbar-right panel_toolbox">
        <slot name="toolbar-start"></slot>
        <slot name="toolbar">
          <li>
            <a 
              v-on:click="togglePanelDisply()"
              title="Hide Panel Contents"
            >
              <i 
                :class="[
                  'fa fa-chevron-up',
                  showPanel ? 'fa-chevron-up' : 'fa-chevron-down'
                ]" 
              >
              </i>
            </a>
          </li>
        </slot>
        <slot name="toolbar-end"></slot>
      </ul>
      <div class="clearfix"></div>
    </div>
    <div 
      v-if="showPanel" 
      class="x_content"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Panel',
  props: {
    filter: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array
    },
    primaryKey: {
      type: String
    },
    searchFields: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      showPanel: true,
      filterText: ''
    }
  },
  methods: {
    clearSearch () {
      this.$set(this, 'filterText', '')
    },
    togglePanelDisply () {
      this.showPanel = (this.showPanel ? 0 : 1)
    },
    findKey () {
      let matches = []
      let regex = new RegExp('^.*' + this.filterText + '.*$', 'i')
      for (let i = 0; this.data.length > i; i++) {
        if (!regex.test(this.data[i].string)) {
          continue
        }
        matches.push(this.data[i])
      }
      this.$emit('matches', matches)
    },
    createSearchStrings () {
      for (let i = 0; this.data.length > i; i++) {
        let searchString = ''
        for (let key in this.data[i]) {
          if (typeof this.data[i][key] !== 'string' && typeof this.data[i][key] !== 'number') {
            continue
          }
          if (this.searchFields.length !== 0 && this.searchFields.indexOf(key) === -1) {
            continue
          }
          searchString += this.data[i][key]
        }
        this.data[i].string = searchString
      }
    }
  },
  watch: {
    filterText () {
      return this.findKey()
    },
    data () {
      this.createSearchStrings()
      this.$emit('matches', this.data)
    }
  }
}
</script>

<style scoped lang="less">
  .panel_toolbox {
    min-width: auto;
  }

  .btn-link.btn-danger {
    margin: 0px;
    color: #d9534f;
    border: 1px solid #ccc;
    border-radius: 0px;
  }

  .input-group {
    input {
      border-left-width: 1px;
    }
    .btn {
      border-right-width: 0px;
    }
  }

  .borderfix {
    &.input-group {
      input {
        border-right-width: 0px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.0);
        box-shadow: inset 0 1px 5px rgba(0,0,0,.0);
      }
      .btn {
        border-right-width: 1px;
        border-left-width: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Panel.vue?3a3351f7